import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'
import api from '../api'
import useDataLoader from '../dataLoader'

const useDeleteManualQueryDocument = (organizationId: number | null) => {
  const token = useSelector(selectToken)
  const deleteDocument = async (documentId: number) => {
    if (organizationId) {
      return await api.deleteManualQueryDocument({ token, organizationId, documentId })
    }
  }

  return useDataLoader(deleteDocument, [], null)
}

export default useDeleteManualQueryDocument
